function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#1a3670;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M41,163v-4H39v4H32v-9.187l-.59.593L30,152.992,40,143l8,8v0l2,2h0l-1.415,1.413L48,153.832V163Zm5-2v-9.168l-6.009-6.008L34,151.813V161h3v-4h6v4Z",
  transform: "translate(-30 -143)"
});

var SvgIconHomeSelected = function SvgIconHomeSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20.002,
    height: 20,
    viewBox: "0 0 20.002 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconHomeSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_home_selected.2134c676.svg";
export { ForwardRef as ReactComponent };